import {Component, EventEmitter, OnInit, Output} from '@angular/core';

@Component({
  selector: 'sg-startgame-dialog',
  templateUrl: './startgame-dialog.component.html',
  styleUrls: ['./startgame-dialog.component.scss']
})
export class StartgameDialogComponent {

  @Output() startgameDialogChange = new EventEmitter();

}
